import React, { Component } from 'react'

import Form from 'components/Form'
import FormGroup from 'components/FormGroup'
import FormErrors from 'components/FormErrors'
import Input from 'components/Input'
import Button from 'components/Button'
import Modal from 'components/Modal'
import Backdrop from 'components/Backdrop'
import Dialog from 'components/Dialog'
import DialogContainer from 'components/DialogContainer'
import DialogContent from 'components/DialogContent'
import DialogClose from 'components/DialogClose'
import DialogTitle from 'components/DialogTitle'
import DialogDescription from 'components/DialogDescription'
import DialogButtons from 'components/DialogButtons'


class ConfirmDialog extends Component {
  componentDidMount() {
    if (this.$input) {
      this.$input.focus()
    }
  }

  handleSubmit = (e) => {
    e.preventDefault()

    if (!this.props.hasVerificationPhrase || this.props.isVerificationPhraseValid) {
      this.props.onConfirm()
    }
  }

  render() {
    return (
      <Form onSubmit={this.handleSubmit}>
        <Modal onClose={this.props.onCancel}>
          <Backdrop onClick={this.props.onCancel} />

          <Dialog>
            <DialogContainer>
              <DialogContent>
                <DialogClose onClose={this.props.onCancel} />

                <DialogTitle>
                  {this.props.title}
                </DialogTitle>

                <DialogDescription>
                  {this.props.description}
                </DialogDescription>

                {this.props.hasVerificationPhrase &&
                  <FormGroup>
                    <Input
                      type="text"
                      value={this.props.verificationPhraseValue}
                      onChange={e => this.props.onVerificationPhraseChange(e.target.value)}
                      placeholder={this.props.verificationPhrasePlaceholder}
                      autoComplete="off"
                      ref={(e) => { this.$input = e }}
                    />

                    <FormErrors
                      errors={this.props.verificationPhraseErrors}
                    />
                  </FormGroup>
                }

                <DialogButtons>
                  <Button
                    variant="white"
                    onClick={this.props.onCancel}
                  >
                    {this.props.cancelLabel || 'Cancel'}
                  </Button>


                  <Button
                    type="submit"
                    variant={this.props.variant}
                    loading={this.props.isWorking}
                    disabled={!(!this.props.hasVerificationPhrase || this.props.isVerificationPhraseValid)}
                  >
                    {this.props.confirmLabel || 'Confirm'}
                  </Button>
                </DialogButtons>

                <FormErrors
                  errors={this.props.generalErrors}
                />
              </DialogContent>
            </DialogContainer>
          </Dialog>
        </Modal>
      </Form>
    )
  }
}

export default ConfirmDialog



// WEBPACK FOOTER //
// ./src/components/ConfirmDialog/index.js